import Form from 'react-bootstrap/Form'
import styled from 'styled-components'

type WidthConfig = string | number | undefined
type WidthConfigField = 'sm' | 'md' | 'lg'
const formatWidthConfig = (field: WidthConfigField) => (props: FormGroupProps): string => {
    const value = props[field]
    if (!value) {
        if (field === 'md') {
            return formatWidthConfig('sm')(props)
        }
        if (field === 'lg') {
            return formatWidthConfig('md')(props)
        }
        return 'width: 100%;'
    }

    // Accept string for value as 25% or 100px
    if (typeof value === 'string') {
        return `width: ${value};`
    }
    // Accept number for as factor as 1/6
    return `width: ${value * 100}%;`
}
export interface FormGroupProps {
    sm?: WidthConfig
    md?: WidthConfig
    lg?: WidthConfig
}
/**
 // For using width based on 12 columns, can use like
 * <FormGroup sm={4/12} />
 // Very flexible api
 * <FormGroup sm={1} md={1/2} lg={1/3} />
 * <FormGroup sm="100%" md="100px" lg="calc(100vw - 100px)" />
 */
export default styled(Form.Group)<FormGroupProps>`
    padding: 0 10px;
    ${formatWidthConfig('sm')}
    @media (min-width: 768px) and (max-width: 992px) {
        ${formatWidthConfig('md')}
    }
    @media (min-width: 992px) {
        ${formatWidthConfig('lg')}
    }
`
